<div class="client-lookup">
  <label *ngIf="label" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
    {{ label }}
  </label>

  <!-- Selected Client Mini Card -->
  <div *ngIf="selectedClientSignal() && showMiniCard" class="mb-3">
    <div class="flex items-center gap-3 p-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800">
      <img *ngIf="selectedClientSignal()?.avatarUrl"
           [src]="selectedClientSignal()?.avatarUrl"
           class="h-10 w-10 rounded-full object-cover"
           [alt]="getClientDisplayName(selectedClientSignal())" />
      <div *ngIf="!selectedClientSignal()?.avatarUrl"
           class="h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-700 grid place-items-center text-sm flex-shrink-0">
        👤
      </div>
      <div class="min-w-0 flex-1">
        <div class="text-sm font-medium text-gray-800 dark:text-white/90 truncate">
          {{ getClientDisplayName(selectedClientSignal()) }}
        </div>
        <div class="text-xs text-gray-500 dark:text-gray-400 truncate">
          {{ selectedClientSignal()?.email }}
        </div>
        <div *ngIf="selectedClientSignal()?.phone" class="text-xs text-gray-500 dark:text-gray-400 truncate">
          {{ selectedClientSignal()?.phone }}
        </div>
      </div>
      <button
        type="button"
        (click)="clearClient()"
        class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition"
        title="Limpiar selección">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Search Input (always show for searching, but hide when client selected with mini card) -->
  <div *ngIf="!selectedClientSignal() || !showMiniCard" class="relative">
    <div class="relative">
      <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      </span>

      <input
        #searchInput
        type="search"
        [formControl]="searchTermControl"
        [placeholder]="placeholder"
        autocomplete="off"
        (focus)="onSearchFocus()"
        (input)="onSearchInput()"
        class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 pl-11 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-2 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />

      <!-- Clear button when client is selected (without mini card) -->
      <button
        *ngIf="selectedClientSignal() && !showMiniCard"
        type="button"
        (click)="clearClient()"
        class="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition"
        title="Limpiar selección">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Selected client display (without mini card) -->
    <div *ngIf="selectedClientSignal() && !showMiniCard" class="mt-2 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
      <div class="text-sm font-medium text-gray-800 dark:text-white/90">
        {{ getClientDisplayName(selectedClientSignal()) }}
      </div>
      <div class="text-xs text-gray-500 dark:text-gray-400">
        {{ selectedClientSignal()?.email }}
      </div>
    </div>

    <!-- Dropdown Results -->
    <div
      #dropdown
      *ngIf="isDropdownOpen()"
      class="absolute z-20 mt-1 w-full rounded-lg border border-gray-200 bg-white dark:bg-gray-900 dark:border-gray-700 shadow-lg max-h-64 overflow-auto">
      <div *ngIf="isSearching()" class="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">
        Buscando...
      </div>
      <div *ngIf="!isSearching() && searchResults().length === 0" class="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">
        Sin resultados
      </div>
      <ul *ngIf="!isSearching() && searchResults().length > 0" class="divide-y divide-gray-200 dark:divide-gray-700">
        <li
          *ngFor="let client of searchResults()"
          (click)="selectClient(client)"
          class="px-4 py-3 flex items-center gap-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition">
          <img *ngIf="client.avatarUrl"
               [src]="client.avatarUrl"
               class="h-8 w-8 rounded-full object-cover flex-shrink-0"
               [alt]="getClientDisplayName(client)" />
          <div *ngIf="!client.avatarUrl"
               class="h-8 w-8 rounded-full bg-gray-200 dark:bg-gray-700 grid place-items-center text-xs text-gray-600 dark:text-gray-300 flex-shrink-0">
            👤
          </div>
          <div class="min-w-0 flex-1">
            <div class="text-sm font-medium text-gray-800 dark:text-white/90 truncate">
              {{ getClientDisplayName(client) }}
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400 truncate">
              {{ client.email }}
            </div>
            <div *ngIf="client.phone" class="text-xs text-gray-500 dark:text-gray-400 truncate">
              {{ client.phone }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

